<template>
      <section v-if="settings" id="Publisher__writer" class="Publisher__writer">


    <div class="writer__box">
      <div class="writer__desc">
        <p> لیست نویسندگان</p>
        <input type="text" v-model="search" name="" placeholder="جستجو نویسنده" id="searchInput">

      </div>
      <div>
        <ul class="somePW">
          <template v-for="author in settings.authors.filter(item=>item.name.includes(search))">
            <li :key="author.id">
            <router-link class="blackColor" :to="`/book-list?author_id[0]=${author.id}`">
              <img :src="author.image" :alt="author.name" />
              <h6>{{ author.name }}</h6>
            </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default{
     computed: {
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  data(){
    return{
      search:""
    }
  },
  mounted(){
     document
        .getElementById("MainHeader")
        .scrollIntoView({ behavior: "smooth" });
    }
  }
   

</script>

<style scoped>
.blackColor{
  color: black;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.Publisher__writer{
  margin-top:20px;
}
ul.somePW {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 5px;
  list-style: none;
    justify-items: center;
    row-gap:15px;

}
.somePW li img{
  width:100px !important;
  height:100px !important;
  object-fit: fill;

  
}
ul.somePW li{
    display: flex;
    flex-direction: column;
    align-items:center
}

@media (max-width: 768px) {
  ul.somePW {
    grid-template-columns: 1fr 1fr 1fr !important;
  }
}
.writer__box{
        box-shadow: 1px 5px 10px #ddd;
    border-radius: 15px;
    flex-grow: 1;
    margin: 1rem;
    padding:30px;
}
 .writer__desc {
    display: flex;
    justify-content: space-between;
    border-right: 4px solid #E48325;
    padding: 0.25rem 1.5rem;
    margin: 1rem 1rem;
}
 .writer__desc p {
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: bolder;
}
input#searchInput {
    padding-bottom: 4px;
    border-bottom: 2px solid #1122118a;
}
</style>